export default "__VITE_ASSET__1N6fWvEE__"